import { render, staticRenderFns } from "./EntryStatusLabel.vue?vue&type=template&id=44fee42f&scoped=true&"
import script from "./EntryStatusLabel.vue?vue&type=script&lang=js&"
export * from "./EntryStatusLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fee42f",
  null
  
)

export default component.exports